import { AddLocationUser } from 'domain/usecases/add-location-user';
import { BaseHttpService } from 'main/factories/http';

export class RemoteAddLocationUser extends BaseHttpService<AddLocationUser.Model> implements AddLocationUser {
  async addLocationUser(params: AddLocationUser.Params): Promise<AddLocationUser.Model> {
    const payload = {
      userId: params.userId,
      email: params.email,
      password: params.password,
      locationId: params.locationId,
      emailOptOut: params.emailOptOut,
      role: params.role,
    };

    return await this.request('post', payload);
  }
}
